import axiosInstance from '../common/axiosInstance'
import { API_ROUTES } from '../common/routes'

export const postLiveComment = (payload) => axiosInstance.post(API_ROUTES.Live.LiveSendMessage, payload)
